import { injectBaseConstantMethods } from "./BaseConstants";

export const GOAL_STATUS = {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE"
};

const displayTextKeys = {
    [GOAL_STATUS.ACTIVE]: "Active",
    [GOAL_STATUS.INACTIVE]: "Inactive"
};

const labelClass = {
    [GOAL_STATUS.ACTIVE]: "cs-badge-active",
    [GOAL_STATUS.INACTIVE]: "cs-badge-inactive"
};

export default injectBaseConstantMethods(GOAL_STATUS, displayTextKeys, labelClass);
